import { AlertMessage, ProgressIndicator } from "../framework/widgets"

import { PageViewer } from "../framework/design/page"
import { useGetPageFromUrl } from "../framework/design/page/hooks"
import { useParams } from "react-router-dom"

export const ViewPageWrapper = () => {
    const { pageId } = useParams();

    if (!pageId) return <></>

    return (
        <div className="position-relative">
            <ViewPageInner pageId={pageId} />
        </div>)
}

const ViewPageInner = ({ pageId }: { pageId: string }) => {
    const { page, pageView, isLoading, isSuccess, isError, error } = useGetPageFromUrl(pageId)

    if (isLoading || !isSuccess || !page || !pageView) {
        return <>
            <ProgressIndicator show={isLoading} className="mb-2" message="Please wait ..." />
            <AlertMessage show={isError} type="Error" message={error} />
        </>
    }

    return <>
        {(pageId === page.id) && <>
            <PageViewer page={page} pageView={pageView} showTitle={true} showRefresh={true} />
        </>}
    </>
}